/* The Graces — LP Coleções (layout Vemus) — tgv-lp.js */
(function () {
  if (window.TGV_LP_INIT) return;
  window.TGV_LP_INIT = true;

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function once(el, key) { if (el.getAttribute('data-tgv-' + key)) return false; el.setAttribute('data-tgv-' + key, '1'); return true; }

  /* ---------- Fade slider (hero + depoimentos) ---------- */
  function initFade(el) {
    if (!once(el, 'fade')) return;
    var slides = qsa(el, '[data-tgv-slide]');
    var dots = qsa(el, '[data-tgv-dot]');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var i = 0, timer = null;
    var delay = parseInt(el.getAttribute('data-delay') || '5000', 10);
    var auto = el.getAttribute('data-autoplay') === 'true';
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
      restart();
    }
    function restart() {
      clearInterval(timer);
      if (auto && !document.hidden) timer = setInterval(function () { go(i + 1); }, delay);
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    qsa(el, '[data-tgv-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    qsa(el, '[data-tgv-goto]').forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-tgv-goto'), 10) || 0); }); });
    qsa(el, '[data-tgv-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
    var sx = null, sy = null;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      sx = null;
    }, { passive: true });
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', restart);
    document.addEventListener('visibilitychange', restart);
    el.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target.closest ? e.target.closest('[data-tgv-slide]') : null);
      if (idx > -1) { auto = false; go(idx); }
    });
    restart();
  }

  /* ---------- Carrossel (scroll-snap) ---------- */
  function initCarousel(el) {
    if (!once(el, 'car')) return;
    var track = el.querySelector('.tgv-track');
    if (!track) return;
    var prev = el.querySelector('[data-tgv-cprev]');
    var next = el.querySelector('[data-tgv-cnext]');
    var dotsWrap = el.querySelector('.tgv-dots');
    var items = Array.prototype.slice.call(track.children);
    function step() {
      var first = items[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function pages() {
      var s = step();
      var perView = Math.max(1, Math.floor((track.clientWidth + 2) / s));
      return Math.max(1, items.length - perView + 1);
    }
    function placeArrows() {
      var m = track.querySelector('.tgv-card__media, .tgv-cat__img, .tgv-post__media');
      if (!m) return;
      var t = m.getBoundingClientRect().top - el.getBoundingClientRect().top + m.offsetHeight / 2;
      [prev, next].forEach(function (b) { if (b) b.style.top = t + 'px'; });
    }
    function buildDots() {
      placeArrows();
      if (!dotsWrap) return;
      var n = Math.min(pages(), 12);
      dotsWrap.innerHTML = '';
      for (var k = 0; k < n; k++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tgv-dot';
        b.setAttribute('aria-label', 'Ir para ' + (k + 1));
        (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); }); })(k);
        dotsWrap.appendChild(b);
      }
      update();
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      el.classList.toggle('no-overflow', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (dotsWrap) {
        var idx = Math.round(track.scrollLeft / step());
        if (track.scrollLeft >= max - 2) idx = dotsWrap.children.length - 1;
        Array.prototype.forEach.call(dotsWrap.children, function (d, k) { d.classList.toggle('is-active', k === idx); });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var raf = null;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; update(); }); }, { passive: true });
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(buildDots, 150); });
    window.addEventListener('load', buildDots);
    buildDots();
  }

  /* ---------- Formulário ActiveCampaign (JSONP, igual ao embed oficial) ---------- */
  function goWA(form) {
    var wa = form.getAttribute('data-wa');
    if (!wa) return false;
    var nameEl = form.querySelector('input[name="fullname"]');
    var name = nameEl ? nameEl.value.trim().split(' ')[0] : '';
    var msg = (form.getAttribute('data-wa-msg') || '').replace(/\{nome\}/g, name).replace(/\s+/g, ' ').trim();
    var stList = qsa(form, 'input[data-tgv-store]:checked').map(function (c) { return c.value; });
    var st = stList.length > 1 ? stList.slice(0, -1).join(', ') + ' e ' + stList[stList.length - 1] : (stList[0] || '');
    if (msg.indexOf('{loja}') > -1) msg = msg.replace(/\{loja\}/g, st);
    else if (st) msg += (stList.length > 1 ? ' Tenho preferência pelas lojas ' : ' Tenho preferência pela loja ') + st + '.';
    var url = wa + (wa.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(msg);
    setTimeout(function () { window.location.href = url; }, 1200);
    return true;
  }
  function initAC(form) {
    if (!once(form, 'ac')) return;
    var msg = form.querySelector('.tgv-nl__msg');
    function show(text, type) {
      if (!msg) return;
      msg.textContent = text;
      msg.className = 'tgv-nl__msg is-show is-' + type;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var account = (form.getAttribute('data-account') || '').replace(/\/+$/, '');
      var email = form.querySelector('input[name="email"]');
      if (!account || !form.querySelector('input[name="u"]').value) {
        show(form.getAttribute('data-msg-config') || 'Formulário ainda não configurado.', 'error');
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
        show(form.getAttribute('data-msg-invalid') || 'Informe um e-mail válido.', 'error');
        if (email) email.focus();
        return;
      }
      var consent = form.querySelector('input[data-tgv-consent]');
      if (consent && !consent.checked) {
        show(form.getAttribute('data-msg-consent') || 'Aceite os termos para continuar.', 'error');
        return;
      }
      var stBox = form.querySelector('[data-tgv-stores][data-req]');
      if (stBox && !stBox.querySelector('input:checked')) {
        show('Selecione ao menos uma loja de sua preferência.', 'error');
        return;
      }
      var params = [];
      qsa(form, 'input[name]').forEach(function (inp) {
        if ((inp.type === 'checkbox' || inp.type === 'radio') && !inp.checked) return;
        if (inp.hasAttribute('data-tgv-consent')) return;
        if (inp.hasAttribute('data-local')) return;
        params.push(encodeURIComponent(inp.name) + '=' + encodeURIComponent(inp.value.trim()));
      });
      qsa(form, 'select[name]:not([data-local])').forEach(function (sel) { if (sel.value) params.push(encodeURIComponent(sel.name) + '=' + encodeURIComponent(sel.value)); });
      params.push('jsonp=true');
      form.classList.add('is-loading');
      var done = false;
      var fail = setTimeout(function () { if (!done) { form.classList.remove('is-loading'); if (goWA(form)) { show(form.getAttribute('data-msg-wa') || 'Redirecionando para o WhatsApp...', 'success'); } else { show(form.getAttribute('data-msg-error') || 'Não foi possível enviar. Tente novamente.', 'error'); } } }, 12000);
      window._show_thank_you = function (id, message) {
        done = true; clearTimeout(fail);
        form.classList.remove('is-loading');
        form.classList.add('is-done');
        show(form.getAttribute('data-msg-success') || message || 'Obrigado!', 'success');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'tgv_lead_activecampaign', form_id: id, lp: form.getAttribute('data-lp') || '' });
        if (goWA(form)) show(form.getAttribute('data-msg-wa') || 'Redirecionando para o WhatsApp...', 'success');
      };
      window._show_error = function (id, message) {
        done = true; clearTimeout(fail);
        form.classList.remove('is-loading');
        var tmp = document.createElement('div'); tmp.innerHTML = message || '';
        if (goWA(form)) { show(form.getAttribute('data-msg-wa') || 'Redirecionando para o WhatsApp...', 'success'); } else { show(tmp.textContent || form.getAttribute('data-msg-error') || 'Erro ao enviar.', 'error'); }
      };
      var s = document.createElement('script');
      s.src = account + '/proc.php?' + params.join('&');
      s.async = true;
      s.onerror = function () { if (!done) { done = true; clearTimeout(fail); form.classList.remove('is-loading'); if (goWA(form)) { show(form.getAttribute('data-msg-wa') || 'Redirecionando para o WhatsApp...', 'success'); } else { show(form.getAttribute('data-msg-error') || 'Não foi possível enviar. Tente novamente.', 'error'); } } };
      document.body.appendChild(s);
    });
  }

  function initAll(root) {
    root = root || document;
    qsa(root, '[data-tgv-fade]').forEach(initFade);
    qsa(root, '[data-tgv-carousel]').forEach(initCarousel);
    qsa(root, 'form[data-tgv-ac]').forEach(initAC);
  }
  window.TGV_LP = { init: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* Telefone: máscara BR + validação antes do envio ao ActiveCampaign */
(function () {
  if (window.TGV_PHONE_INIT) return;
  window.TGV_PHONE_INIT = true;
  function fmt(v) {
    var d = v.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-tgv-phone')) t.value = fmt(t.value);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-tgv-ac')) return;
    var p = form.querySelector('input[data-tgv-phone]');
    if (!p) return;
    var digits = p.value.replace(/\D/g, '');
    if ((p.hasAttribute('data-req') && digits.length < 10) || (digits.length > 0 && digits.length < 10)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var msg = form.querySelector('.tgv-nl__msg');
      if (msg) { msg.textContent = 'Informe um telefone válido com DDD.'; msg.className = 'tgv-nl__msg is-show is-error'; }
      p.focus();
    }
  }, true);
})();


/* TG: carrosseis - arrastar com o mouse + passagem automatica (pausa ao passar o mouse) */
(function () {
  if (window.TGV_DRAG_INIT) return;
  window.TGV_DRAG_INIT = true;
  function setup(el) {
    if (el.__tgDrag) return; el.__tgDrag = true;
    var track = el.querySelector('.tgv-track'); if (!track) return;
    var down = false, moved = false, sx = 0, sl = 0, hover = false, timer = null;
    track.style.cursor = 'grab';
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; sx = e.pageX; sl = track.scrollLeft;
      track.style.cursor = 'grabbing'; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto';
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx; if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return; down = false;
      track.style.cursor = 'grab'; track.style.scrollBehavior = '';
      setTimeout(function () { track.style.scrollSnapType = ''; }, 50);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('mouseenter', function () { hover = true; });
    el.addEventListener('mouseleave', function () { hover = false; });
    function stepW() { var f = track.children[0]; if (!f) return track.clientWidth; var g = parseFloat(getComputedStyle(track).columnGap) || 0; return f.getBoundingClientRect().width + g; }
    timer = setInterval(function () {
      if (hover || down || document.hidden) return;
      var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      var max = track.scrollWidth - track.clientWidth; if (max <= 4) return;
      if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: stepW(), behavior: 'smooth' });
    }, 4000);
  }
  function all(root) { (root || document).querySelectorAll('[data-tgv-carousel]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
